import React from 'react';
import Select from 'react-select';

const Specifiers = ({ specifiers, marketsList, setSelectedSpecifier, selectedSpecifierMarket }) => {
    return specifiers.map((specifier, index) => {
        const specifierOptions = marketsList
            .map(market => {
                if (!market.specifiers || !market.specifiers[index]) return null;

                return {
                    value: market.id,
                    label: market.specifiers[index].value,
                };
            })
            .filter(v => !!v);

        return (
            <td key={specifier}>
                <Select
                    className='common-select common-select--specifiers'
                    classNamePrefix='common'
                    menuPlacement={'auto'}
                    isSearchable={false}
                    value={{
                        value: selectedSpecifierMarket.id,
                        label: selectedSpecifierMarket.specifiers?.[index]?.value ?? '',
                    }}
                    onChange={v => setSelectedSpecifier(v.value)}
                    options={specifierOptions}
                />
            </td>
        );
    });
};

export default Specifiers;
